<template>
    <div>
      <div class="row">
        <div class="col-12 your-details">
          <div>
            <div class="card with-padding with-shadow details">
              <div class="row">
                <div class="col-5">
                  <ul>
                    <li>
                      <span class="key">Driver Name: </span>
                      <span class="value">{{ profile.fullName }}</span>
                    </li>
                    <li>
                      <span class="key">Driver Email: </span>
                      <span class="value">{{ profile.emailAddress }}</span>
                    </li>
                    <li>
                      <span class="key">Driver Grade: </span>
                      <span class="value">{{ profile.privateCarGrade }}</span>
                    </li>
                  </ul>
                </div>
                <div class="col-5">
                  <ul>
                    <li>
                      <span class="key">Mobile phone: </span>
                      <span class="value">{{ profile.mobile }}</span>
                    </li>
                    <li>
                        <span class="key">Tax Band:
<!--                            <VDropdown :disabled="!tooltip">
                                <button class="tooltip-button"><i class="icon-info-solid"/></button>
                                <template #popper>
                                    <p>{{ taxBandTooltip }}</p>
                                </template>
                            </VDropdown>-->
                        </span>
                      <span class="value">{{ profile.incomeTaxBand }}%</span>
                    </li>
                  </ul>
                </div>
                <div class="col-2 text-right">
                  <button aria-label="Edit my details" @click.prevent="showEditDriverForm" class="button button--xsmall button--steelBlue-ghost">
                    Edit my details
                  </button>
<!--                  <button href="" aria-label="Set charging profile" @click.prevent="showChargingProfileForm" class="button button&#45;&#45;xsmall button&#45;&#45;steelBlue-ghost">
                    Set charging profile
                  </button>-->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="slideout" :class="{ 'slideout--show' : slideoutVisible }">
      <div v-if="slideoutVisible">

        <!-- Header -->
        <div class="row">
          <div class="col-10 text-start">
            <div>
              <h3><span>{{ product.scheme_card_main_driver_heading_text }}</span></h3>
              <p>{{ product.scheme_card_main_driver_heading_description }}</p>

              <form method="POST" @submit.prevent="updateDriverProfile" id="edit-driver-profile-form">

                <h6>Driver Name:</h6>

                <div class="row mb-4">
                  <div class="col-6">
                    <div class="input firstname">
                      <input type="text" class="firstname" name="firstname"
                        id="driver-profile-firstname" v-model="payload.firstname" required>
                      <label for="driver-profile-firstname">Firstname</label>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="input surname">
                      <input type="text" class="surname" name="surname"
                        id="driver-profile-surname" v-model="payload.surname" required>
                      <label for="driver-profile-surname">Surname</label>
                    </div>
                  </div>
                </div>

                <div class="row mb-4">
                  <div class="col-12">
                    <div class="input email">
                      <input type="email" class="email" name="email" id="driver-profile-email"
                        v-model="payload.email" required>
                      <label for="driver-profile-email">Driver Email</label>
                    </div>
                  </div>
                </div>

                <p class="mb-2">{{ product.your_profile_form_address }}</p>

                <div class="row mb-4">
                  <div class="col-12">
                    <div class="input address">
                      <input type="text" class="address" name="address"
                        id="driver-profile-address" v-model="payload.address" required>
                      <label for="driver-profile-address">Address</label>
                    </div>
                  </div>
                </div>

                <div class="row mb-4">
                  <div class="col-12">
                    <div class="input postcode">
                      <input type="text" class="postcode" name="postcode"
                        id="driver-profile-postcode" v-model="payload.postcode" required>
                      <label for="driver-profile-postcode">Postcode</label>
                    </div>
                  </div>
                </div>

                <div class="row mb-4">
                  <div class="col-12">
                    <div class="input mobile-phone">
                      <input type="text" class="mobile-phone" name="mobilePhone"
                        id="driver-profile-mobile-phone" v-model="payload.mobilePhone" required>
                      <label for="driver-profile-mobile-phone">Mobile Phone</label>
                    </div>
                  </div>
                </div>

                <div class="row mb-4" v-if="showDrivingLicense">
                  <div class="col-12">
                    <div class="input driving-license">
                      <input type="text" class="driving-license" name="drivingLicense"
                        id="driver-profile-driving-license" v-model="payload.drivingLicense"
                        required>
                      <label for="driver-profile-driving-license">Driving License #:</label>
                    </div>
                  </div>
                </div>

                <div class="row mb-4">
                  <div class="col-12">
                    <div class="custom-multiselect">
                      <label for="driver-profile-tax-band">Tax Band (%)</label>
                      <multiselect
                        id="driver-profile-tax-band"
                        v-model="payload.taxBand"
                        :options="taxBands"
                        group-values="options"
                        group-label="group"
                        :group-select="false"
                        :show-labels="false"
                      >
                      </multiselect>
                    </div>
                  </div>
                </div>

                <input type="submit" value="Save" class="button button--steelBlue float-right">

              </form>
            </div>
          </div>
          <div class="col-2 text-end">
            <button @click="hideSlideout" class="close"><i class="icon-cross"></i></button>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-5">
      <div class="col-12">
        <div class="card with-padding card--viridian-green essential-business-scheme mb-3">
          <h3>Your company car scheme</h3>
          <div v-html="product.scheme_card_scheme_description"></div>
        </div>
      </div>
    </div>

</template>

<script>

import {EventBus} from '@/event-bus.js';
import Multiselect from 'vue-multiselect';

export default {
  name: 'bch-your-details-component',
  components: {
    Multiselect
  },

  props: [
    'mileagePercent',
    'profile',
    'product',
    'schemeType',
    'tooltip',
    'taxBandTooltip',
    'adminPortalData'
  ],

  computed: {
    showDrivingLicense() {
      return this.adminPortalData?.content?.products?.bch[0].display_settings_show_driving_license_main_driver;
    }
  },

  data() {
    return {
      slideoutVisible: false,
      taxBands: [
        {
          group: 'Tax Rates',
          options: [20, 40, 45]
        },
        /*{
          group: 'Scottish Tax Rates',
          options: [19, 21, 42, 48]
        }*/
      ],
      payload: {
        firstname: null,
        surname: null,
        email: null,
        address: null,
        postcode: null,
        mobilePhone: null,
        drivingLicense: null,
        taxBand: null,
        mainDriver: true,
      },
    };
  },

  mounted() {
    EventBus.$on('editProfile', (editProfile) => {
      this.showEditDriverForm();
    });
  },

  methods: {
    showSlideout(context) {
      this.slideoutVisible = true;
    },

    hideSlideout() {
      this.slideoutVisible = false;
    },

    showEditDriverForm() {
      this.payload = {
        firstname: this.getFirstName(),
        surname: this.getSurname(),
        email: this.profile.emailAddress,
        address: this.profile.homeAddress,
        postcode: this.profile.postcode,
        mobilePhone: this.profile.mobile,
        drivingLicense: this.profile.driverLicence?.licenceNumber,
        taxBand: this.profile.incomeTaxBand,
        mainDriver: true,
        scheme: 'bch',
      }

      this.showSlideout();
    },

    getFirstName() {
      const parts = this.profile.fullName.split(' ');
      return parts.length ? parts[0] : '';
    },

    getSurname() {
      const parts = this.profile.fullName.split(' ');
      return parts.length ? parts[parts.length - 1] : '';
    },

    updateDriverProfile() {

      EventBus.$emit('loadingTitle', 'Updating Driver Profile');
      EventBus.$emit('loading', true);

      this.$http.post('/api/your-profile', this.payload)
        .then(response => {
          EventBus.$emit('loading', false);

          this.$notify({
            group: 'notify',
            type: 'success',
            title: 'Success',
            text: 'Driver Profile saved successfully'
          });

          this.hideSlideout();

          EventBus.$emit('reload-driver-profile');
        })
        .catch(err => {
          EventBus.$emit('loading', false);
          let response = err.response.data;

          this.$notify({
            group: 'notify',
            type: 'error',
            title: 'Error',
            text: response.error.message
          });
        });
    },
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.css"></style>

